import { BLANK_NEW_ASSIGNMENT_DATAS, BLANK_DUB_EDITOR_DATAS, getBlankAssignmentForm } from "@/utils/assignmentUtils";
const iTunesWorkTypeReference = {
  "en-US": {
    "cs-CZ": "LOC_10-04-16",
    "el-GR": "LOC_09-02-17",
    "it-IT": "LOC_09-02-18",
    "nl-NL": "LOC_12-02-23",
    "pt-PT": "LOC_09-02-17",
    "ru-RU": "LOC_07-02-14",
    "uk-UA": "LOC_09-02-16",
    "es-US": "LOC_09-02-17",
    "es-ES": "LOC_09-02-16",
    "pl-PL": "LOC_08-01-16",
    "es-MX": "LOC_09-02-16",
    "de-DE": "LOC_13-02-25",
    "de-CH": "LOC_13-02-23",
    "ar-SA": "LOC_09-03-19",
    "ja-JP": "LOC_15-05-30",
    "ko-KR": "LOC_12-06-27",
    "hu-HU": "LOC_09-03-16",
  },
  "en-GB": {
    "cs-CZ": "LOC_10-04-16",
    "el-GR": "LOC_09-02-17",
    "it-IT": "LOC_09-02-18",
    "nl-NL": "LOC_12-02-23",
    "pt-PT": "LOC_09-02-17",
    "ru-RU": "LOC_07-02-14",
    "uk-UA": "LOC_09-02-16",
    "es-US": "LOC_09-02-17",
    "es-ES": "LOC_09-02-16",
    "pl-PL": "LOC_08-01-16",
    "es-MX": "LOC_09-02-16",
    "de-DE": "LOC_13-02-25",
    "de-CH": "LOC_13-02-23",
    "ar-SA": "LOC_09-03-19",
    "ja-JP": "LOC_15-05-30",
    "ko-KR": "LOC_12-06-27",
    "hu-HU": "LOC_09-03-16",
  },
  "ko-KR": {
    "en-US": "LOC_13-02-26",
    "en-GB": "LOC_13-02-26",
  },
};

export const assignmentModule = {
  state: () => ({
    // modals
    newAssignmentModalOpen: false,
    hoursSubmissionModalOpen: false,
    logWorkTypeModalOpen: false,
    dubEditorModalOpen: false,
    // assignments
    newAssignmentDatas: BLANK_NEW_ASSIGNMENT_DATAS,
    dubEditorDatas: BLANK_DUB_EDITOR_DATAS,
    geoOptions: [],
    keywordsOptions: [],
    mediaTypeOptions: [],
    workTypeReferences: [],
    requestTypeOptions: [],
    keywordOptions: [],
    statusOptions: [],
    assignmentTitleOptions: [],
    departmentOptions: [],
    projectsList: [],
    driList: [],
    assignmentsDeepClone: [],
    bulkEditing: false,
    bulkQueryEdit: false,
    updateBatchConfirmation: false,
    updatePPCheckModal: false,
    updatePPCheckValue: null,
    jumpOverPPCheck: true,
    hoursSubmissionAssignmentInfo: null,
    staffHoursData: [],
    staffReview: false,
    isEditing: false,
    // new assignment form
    relatedWriters: [],
    relatedEditors: [],
    reviewers: [],
    assignmentForm: getBlankAssignmentForm(),
    iTunesWorkType1ReferencesConditions: {
      Localization: iTunesWorkTypeReference,
      Adaptation: {
        "de-DE": {
          "de-CH": "ADP_04-00-09",
        },
        "en-US": {
          "en-AU": "ADP_04-00-06",
          "en-GB": "ADP_04-00-06",
          "en-CA": "ADP_04-00-06",
        },
      },
    },
    iTunesWorkType2References: ["CWR_1000-120-1500"],
    iTunesWorkType3References: ["CWR_1500-180-2800"],
    iTunesWorkType4References: [
      "CWR_2500-300-3800",
      "CWR_1000-380-3800",
      "CWR_1500-380-3800",
      "Playlist Long Copy < 400 (200) cc",
      "Playlist Extended Long Copy < 600 (200) cc",
    ],
    iTunesWorkType5References: ["CWR_5000-500-7000"],
    iTunesWorkType6References: ["CWR_300-100-500"],
    editingWorkType: null,
  }),
  mutations: {
    SET_NEW_ASSIGNMENT_MODAL_OPEN(state, assignmentModalOpen) {
      state.newAssignmentModalOpen = assignmentModalOpen;
    },
    SET_HOURS_SUBMISSION_MODAL_OPEN(state, hoursSubmissionModalOpen) {
      state.hoursSubmissionModalOpen = hoursSubmissionModalOpen;
    },
    SET_LOG_WORK_TYPE_MODAL_OPEN(state, logWorkTypeModalOpen) {
      state.logWorkTypeModalOpen = logWorkTypeModalOpen;
    },
    SET_NEW_ASSIGNMENT_DATAS(state, newDatas) {
      state.newAssignmentDatas = newDatas;
    },
    SET_DUB_EDITOR_MODAL_OPEN(state, dubEditorModalOpen) {
      state.dubEditorModalOpen = dubEditorModalOpen;
    },
    SET_DUB_EDITOR_DATAS(state, dubEditorDatas) {
      state.dubEditorDatas = dubEditorDatas;
    },
    RESET_NEW_ASSIGNMENT_DATAS(state) {
      state.newAssignmentDatas = [...BLANK_NEW_ASSIGNMENT_DATAS];
    },
    DELETE_NEW_ASSIGNMENT_DATAS(state, datasIndex) {
      state.newAssignmentDatas.splice(datasIndex, 1);
    },
    SET_ASSIGNMENTS_DEEP_CLONE(state, assignmentsDeepClone) {
      state.assignmentsDeepClone = assignmentsDeepClone;
    },
    SET_COMMON_DATA(state, { field, data }) {
      state[field] = [...data];
    },
    SET_BULK_EDITING(state, bulkEditing) {
      state.bulkEditing = bulkEditing;
    },
    SET_BULK_QUERY_EDIT(state, bulkQueryEdit) {
      state.bulkQueryEdit = bulkQueryEdit;
    },
    SET_UPDATE_BATCH_CONFIRMATION(state, updateBatchConfirmation) {
      state.updateBatchConfirmation = updateBatchConfirmation;
    },
    SET_UPDATE_PP_CHECK_MODAL(state, updatePPCheckModal) {
      state.updatePPCheckModal = updatePPCheckModal;
    },
    SET_JUMP_OVER_PP_CHECK(state, jumpOverPPCheck) {
      state.jumpOverPPCheck = jumpOverPPCheck;
    },
    SET_UPDATE_PP_CHECK_VALUE(state, updatePPCheckValue) {
      state.updatePPCheckValue = updatePPCheckValue;
    },
    SET_HOURS_SUBMISSION_ASSIGNMENT_INFO(state, hoursSubmissionAssignmentInfo) {
      state.hoursSubmissionAssignmentInfo = hoursSubmissionAssignmentInfo;
    },
    SET_STAFF_HOURS_DATA(state, staffHoursData) {
      state.staffHoursData = staffHoursData;
    },
    SET_STAFF_REVIEW(state, staffReview) {
      state.staffReview = staffReview;
    },
    SET_IS_EDITING(state, data) {
      state.isEditing = data;
    },
    UPDATE_ASSIGNMENT(state, { field, data }) {
      state.assignmentForm[field] = data;
    },
    SET_STAFF_BY_GEO(state, payload) {
      const {
        selectedGeo
      } = payload

      console.log('SET_STAFF_BY_GEO', selectedGeo, state.assignmentForm.relatedProject)
      const writers = state.assignmentForm.relatedProject.staff?.length
        ? state.assignmentForm.relatedProject.staff
            .filter(el => el.adminDetails.geos.includes(selectedGeo))
            .map(el => ({
              ...el,
              disabled: false,
            }))
            .sort((a, b) =>
              a.user.firstName.localeCompare(b.user.firstName)
            )
        : []

        console.log('SET_STAFF_BY_GEO list', state.assignmentForm.relatedProject.staff
            .filter(el => el.adminDetails.geos.includes(selectedGeo)))

      state.relatedWriters = writers
      state.relatedEditors = [...writers]
      state.reviewers = [...writers]

      const getUserId = (role) =>
        state.assignmentForm[role]?.id

      state.writer =
        writers.find(el => el.user?.id === getUserId('primary')) ?? null

      state.editor =
        state.relatedEditors.find(el => el.user?.id === getUserId('secondary')) ?? null

      state.reviewer =
        writers.find(el => el.user?.id === getUserId('qc')) ?? null

        console.log('SET_STAFF_BY_GEO writers', writers)
    },
    ADD_WORK_TYPE_REFERENCE(state, workTypeReference) {
      state.assignmentForm.pricing.workTypes.push(workTypeReference);
    },
    SET_EDITING_WORK_TYPE(state, payload) {
      state.editingWorkType = payload;
    },
    UPDATE_WORK_TYPE(state, { index, workType }) {
      if (index !== null && index !== undefined) {
        state.assignmentForm.pricing.workTypes.splice(index, 1, workType);
      } else {
        state.assignmentForm.pricing.workTypes.push(workType);
      }
    },
    SET_ASSIGNMENT_FORM(state, payload) {
      state.assignmentForm = payload;
    },
    RESET_ASSIGNMENT_FORM(state) {
      state.assignmentForm = getBlankAssignmentForm();
      state.relatedWriters = [];
      state.relatedEditors = [];
      state.reviewers = [];
    }
  },
  actions: {
    setNewAssignmentModalOpen(context, assignmentModalOpen) {
      if (!assignmentModalOpen) {
        context.commit("RESET_NEW_ASSIGNMENT_DATAS");
        context.commit("SET_BULK_EDITING", false);
      }
      context.commit("SET_NEW_ASSIGNMENT_MODAL_OPEN", assignmentModalOpen);
    },
    setIsEditing({ commit }, data) {
      commit("SET_IS_EDITING", data);
    },
    setHoursSubmissionModalOpen(context, data) {
      if (data.assignmentInfo) context.commit("SET_HOURS_SUBMISSION_ASSIGNMENT_INFO", data.assignmentInfo);
      context.commit("SET_HOURS_SUBMISSION_MODAL_OPEN", data.status);
    },
    setLogWorkTypeModalOpen(context, logWorkTypeModalOpen) {
      context.commit("SET_LOG_WORK_TYPE_MODAL_OPEN", logWorkTypeModalOpen);
    },
    setDubEditorModalOpen(context, dubEditorModalOpen) {
      context.commit("SET_DUB_EDITOR_MODAL_OPEN", dubEditorModalOpen);
    },
    setNewAssignmentDatas(context, newDatas) {
      context.commit("SET_NEW_ASSIGNMENT_DATAS", newDatas);
    },
    setDubEditorDatas(context, dubEditorDatas) {
      context.commit("SET_DUB_EDITOR_DATAS", dubEditorDatas);
    },
    setAssignmentsDeepClone(context, assignmentsDeepClone) {
      context.commit("SET_ASSIGNMENTS_DEEP_CLONE", assignmentsDeepClone);
    },
    deleteNewAssignmentDatas(context, datasIndex) {
      context.commit("DELETE_NEW_ASSIGNMENT_DATAS", datasIndex);
    },
    setCommonData(context, { field, data }) {
      context.commit("SET_COMMON_DATA", { field, data });
    },
    setBulkEditing(context, bulkEditing) {
      context.commit("SET_BULK_EDITING", bulkEditing);
    },
    setBulkQueryEdit(context, bulkQueryEdit) {
      context.commit("SET_BULK_QUERY_EDIT", bulkQueryEdit);
    },
    setUpdateBatchConfirmation(context, updateBatchConfirmation) {
      context.commit("SET_UPDATE_BATCH_CONFIRMATION", updateBatchConfirmation);
    },
    setUpdatePPCheckModal(context, updatePPCheckModal) {
      context.commit("SET_UPDATE_PP_CHECK_MODAL", updatePPCheckModal);
    },
    setJumpOverPPCheck(context, jumpOverPPCheck) {
      context.commit("SET_JUMP_OVER_PP_CHECK", jumpOverPPCheck);
    },
    setUpdatePPCheckValue(context, updatePPCheckValue) {
      context.commit("SET_UPDATE_PP_CHECK_VALUE", updatePPCheckValue);
    },
    setStaffHoursData(context, staffHoursData) {
      context.commit("SET_STAFF_HOURS_DATA", staffHoursData);
    },
    openReviewModal(context, review) {
      context.commit("SET_STAFF_REVIEW", review);
    },
    updateAssignmentData(context, { field, data }) {
      context.commit("UPDATE_ASSIGNMENT", { field, data });
    },
    getStaffByGeo({ commit }, payload) {
      commit('SET_STAFF_BY_GEO', payload)
    },
    addWorkTypeReference(context, workTypeReference) {
      console.log("workTypeReference", workTypeReference);
      context.commit("ADD_WORK_TYPE_REFERENCE", workTypeReference);
    },
    setEditingWorkType({ commit }, payload) {
      commit("SET_EDITING_WORK_TYPE", payload);
    },
    updateWorkType({ commit }, payload) {
      commit('UPDATE_WORK_TYPE', payload);
    },
    setAssignmentForm({ commit }, payload) {
      commit("SET_ASSIGNMENT_FORM", payload);
    },
    resetAssignmentForm({ commit }) {
      commit("RESET_ASSIGNMENT_FORM");
    }
  },
  getters: {
    newAssignmentModalOpen: (state) => {
      return state.newAssignmentModalOpen;
    },
    hoursSubmissionModalOpen: (state) => {
      return state.hoursSubmissionModalOpen;
    },
    logWorkTypeModalOpen: (state) => {
      return state.logWorkTypeModalOpen;
    },
    dubEditorModalOpen: (state) => {
      return state.dubEditorModalOpen;
    },
    newAssignmentDatas: (state) => {
      return state.newAssignmentDatas;
    },
    dubEditorDatas: (state) => {
      return state.dubEditorDatas;
    },
    geoOptions: (state) => {
      return state.geoOptions;
    },
    mediaTypeOptions: (state) => {
      return state.mediaTypeOptions;
    },
    keywordOptions: (state) => {
      return state.keywordOptions;
    },
    departmentOptions: (state) => {
      return state.departmentOptions;
    },
    workTypeReferences: (state) => {
      return state.workTypeReferences;
    },
    requestTypeOptions: (state) => {
      return state.requestTypeOptions;
    },
    statusOptions: (state) => {
      return state.statusOptions;
    },
    assignmentTitleOptions: (state) => {
      return state.assignmentTitleOptions;
    },
    projectsList: (state) => {
      return state.projectsList;
    },
    driList: (state) => {
      return state.driList;
    },
    isEditMode: (state) => {
      return state.newAssignmentDatas[0].hasOwnProperty("id");
    },
    assignmentsDeepClone: (state) => {
      return state.assignmentsDeepClone;
    },
    bulkEditing: (state) => {
      return state.bulkEditing;
    },
    bulkQueryEdit: (state) => {
      return state.bulkQueryEdit;
    },
    updateBatchConfirmation: (state) => {
      return state.updateBatchConfirmation;
    },
    updatePPCheckModal: (state) => {
      return state.updatePPCheckModal;
    },
    jumpOverPPCheck: (state) => {
      return state.jumpOverPPCheck;
    },
    updatePPCheckValue: (state) => {
      return state.updatePPCheckValue;
    },
    hoursSubmissionAssignmentInfo: (state) => {
      return state.hoursSubmissionAssignmentInfo;
    },
    staffHoursData: (state) => {
      return state.staffHoursData;
    },
    staffReviewStatus: (state) => {
      return state.staffReview;
    },
    assignmentForm: (state) => {
      return state.assignmentForm;
    },
    relatedWriters: (state) => {
      return state.relatedWriters;
    },
    relatedEditors: (state) => {
      return state.relatedEditors;
    },
    reviewers: (state) => {
      return state.reviewers;
    },
    iTunesWorkType1References(state) {
      const requestType = state.assignmentForm.requestType;
      const sourceGeo = state.assignmentForm.sourceGeo;
      const geo = state.assignmentForm.geo;

      if (requestType === "Copywriting") {
        return [
          "CWR_500-60-1100",
          "CWR_2500-00-4500",
          "CWR_3500-00-4500",
          "CWR_1000-00-00",
        ];
      }

      const condition =
        state.iTunesWorkType1ReferencesConditions?.[requestType]?.[
          sourceGeo
        ]?.[geo];

      if (condition) {
        return [
          condition,
          "LOC_2500-00-3800",
          "LOC_2500-00-4500",
          "LOC_3500-00-4500",
          "LOC_300-100-700",
          "LOC_13-02-26",
        ];
      }

      return state.workTypeReferences.map(el => el.workTypeName);
    },
    editingWorkType(state) {
      return state.editingWorkType;
    }
  },
};
